import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CardMedia from '@material-ui/core/CardMedia';
import CardActionArea from '@material-ui/core/CardActionArea';
import Button from '@material-ui/core/Button';
// import Container from '@material-ui/core/Container';
import { NavLink } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    height: '100%',
    padding: theme.spacing(4),
    boxShadow: 'none'
  },
  section: {
    padding: '5rem 0',
    backgroundColor: 'white'
  },
  headerImage: {
    height: '70vh',
    minHeight: '50rem',
    backgroundImage: 'url(./img/header/header.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center center'
  }
}));

const Mobile = () => {
  const classes = useStyles();

  return (
    <>

      {/* <Container
        className={classes.headerImage}
        maxWidth="false"
      /> */}
      <Grid
        className={classes.section}
        component="header"
        container
      >
        <Grid
          item
          md={7}
          sm={12}
          xs={12}
        >
          <Paper
            className={classes.paper}
          >
            <Typography variant="h1">
              Le premier jeu vidéo <br />
              <span style={{color: '#70C359'}}>
                ECO-RESPONSABLE
              </span>
            </Typography>
            <Typography
              component="p"
              variant="body2"
            >
              SeedOut Fenua est un jeu vidéo mobile multijoueurs et coopératif qui sensibilise aux enjeux de la reforestation dans un univers inspiré de la culture Polynésienne.
            </Typography>
            <Typography
              component="p"
              variant="body2"
            >
              Chaque arbre virtuel planté qui atteint le stade adulte est un arbre réel qui prend vie.
            </Typography>
            <NavLink to="/your-impact">
              <Button
                color="secondary"
                size="large"
                style={{marginTop: '2rem'}}
                variant="contained"
              >
              DECOUVREZ VOTRE IMPACT
              </Button>
            </NavLink>
          </Paper>
        </Grid>
        <Grid
          item
          md={5}
          sm={12}
          xs={12}
        >
          <Paper className={classes.paper}>
            <CardMedia
              alt="Téléphone mobile avec avec une capture d'écran du jeu SeedOut"
              className={classes.media}
              component="img"
              image="./img/home/home_phone.webp"
              object-fit
              title="SeedOut Fenua - Un jeu téléphone mobile"
            />
            <Grid
              container
              style={{marginTop: '1rem', padding: '2rem'}}
            >
              <Typography
                align="center"
                style={{marginBottom: '2rem'}}
              >
                SeedOut Fenua sera est encore à l'état de developpement. Il sera bientôt disponible en version bétâ sur IOS et Android</Typography>
              <Grid
                item
                xs
              >
                <CardActionArea>
                  <CardMedia
                    alt="Icone apple store designed by web factory"
                    className={classes.media}
                    component="img"
                    image="./img/home/store_apple.webp"
                    object-fit
                    title="Telecharger Seedout sur Apple Store"
                  />
                </CardActionArea>
              </Grid>
              <Grid xs={1} />
              <Grid
                item
                xs
              >
                <CardActionArea>
                  <CardMedia
                    alt="Icone google play designed by web factory"
                    className={classes.media}
                    component="img"
                    image="./img/home/store_google.webp"
                    object-fit
                    title="Telecharger Seedout sur Google Play"
                  />
                </CardActionArea>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

export default Mobile;
